import React, { useState, useEffect, useContext } from 'react';
import { RootStoreContext } from '../stores/RootStore';
import { Detail } from '../models/StudyEvaluation';
import { Link } from 'react-router-dom';

const HistoryDetailPage: React.FC<any> = (props) => {

    const history_id = props.location.state.historyid;
    const emplid = props.location.state.emplid;
    const institutionVal = props.location.state.institution;
    const careerVal = props.location.state.career;
    const semesterVal = props.location.state.semester;
    const programByinstitutionVal = props.location.state.program;

    const rootStore = useContext(RootStoreContext);
    const { getHistoryDetail } = rootStore.studyEvaluationStore;
    const [list, setList] = useState<Detail>()

    useEffect(() => {

        getHistoryDetail(history_id).then(function (response) {
            setList(response);
        })

    }, [])

    console.log(list)


    const renderHistory = () => {

        return list?.detail.map((item, index) => {
            return (
                <React.Fragment>
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.STATUS}</td>
                        <td>{item.REMARKS}</td>
                        <td>{item.REVIEWED_BY}</td>
                        <td>{item.REVIEWED_DATE}</td>
                    </tr>
                </React.Fragment>
            );
        })
    }

    const renderDetailHistory = () => {

        return list?.historywl.map((item, index) => {
            return (
                <React.Fragment>
                    <tr key={index}>
                        <td>{item.SEMESTER_KE}</td>
                        <td>{item.SEMESTER}</td>
                        <td>{item.SKS}</td>
                        <td>{item.IPS}</td>
                        <td>{item.IPK}</td>
                        <td>{item.WARNING_LETTER}</td>
                        <td>{item.WL_NO}</td>
                    </tr>
                </React.Fragment>
            );
        })
    }

    const renderHeader = () => {
        return list?.header.map((item, index) => {
            return (
                <React.Fragment>
                    <tr key={item.EMPLID}>
                        <td>Id</td>
                        <td>{item.EMPLID}</td>
                    </tr>
                    <tr key={item.NAME_DISPLAY}>
                        <td>Name</td>
                        <td>{item.NAME_DISPLAY}</td>
                    </tr>
                    <tr key={item.ACAD_PROGRAM}>
                        <td>Program</td>
                        <td>{item.ACAD_PROGRAM}</td>
                    </tr>
                    <tr key={item.CLASS_OF}>
                        <td>Class Of</td>
                        <td>{item.CLASS_OF}</td>
                    </tr>
                    <tr key={item.ADVISOR_NAME}>
                        <td>Advisor</td>
                        <td>{item.ADVISOR_NAME}</td>
                    </tr>
                    <tr key={item.SEMESTER}>
                        <td>Semester</td>
                        <td>{item.SEMESTER}</td>
                    </tr>
                    <tr key={item.WARNING_LETTER}>
                        <td>Warning Letter</td>
                        <td>{item.WARNING_LETTER}</td>
                    </tr>
                </React.Fragment>
            );
        })
    }

    return (
        <React.Fragment>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <Link
                                className="btn btn-danger"
                                to={{
                                    pathname: "/history",
                                    state: {
                                        institutionVal: institutionVal,
                                        careerVal: careerVal,
                                        semesterVal:semesterVal,
                                        programByinstitutionVal:programByinstitutionVal
                                    }
                                }}
                            >
                                Back to History List
                            </Link>
                            <br /><br />
                            <h1 className="m-0">History Detail</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">

                            <div className="card">
                                <div className="card-body table-responsive p-0">

                                    <div className="col-6">
                                        <table className="table table-hover text-nowrap">
                                            <tbody>
                                                {renderHeader()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Approval</h3>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Status</th>
                                                <th>Remarks</th>
                                                <th>Reviewed By</th>
                                                <th>Reviewed Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderHistory()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Study Evaluation History</h3>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Semester #</th>
                                                <th>Semester</th>
                                                <th>SKS</th>
                                                <th>IPS</th>
                                                <th>IPK</th>
                                                <th>Warning Letter</th>
                                                <th>Reference Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderDetailHistory()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default HistoryDetailPage;